export interface EasternSign {
    key: string;
    title: string;
    symbol: string;
    element: 'wood' | 'fire' | 'earth' | 'metal' | 'water';
    elementTitle: string;
    color: string;
    bgGradient: string;
    yearsDescription?: string;
}

export const EASTERN_SIGNS: EasternSign[] = [
    {
        key: 'rat',
        title: 'Крыса',
        symbol: '🐀',
        element: 'water',
        elementTitle: 'Вода',
        color: '#1e88e5',
        bgGradient: 'linear-gradient(135deg, #42a5f5 0%, #1565c0 100%)',
        yearsDescription: '1960, 1972, 1984, 1996, 2008, 2020'
    },
    {
        key: 'ox',
        title: 'Бык',
        symbol: '🐂',
        element: 'earth',
        elementTitle: 'Земля',
        color: '#5d4037',
        bgGradient: 'linear-gradient(135deg, #8d6e63 0%, #4e342e 100%)',
        yearsDescription: '1961, 1973, 1985, 1997, 2009, 2021'
    },
    {
        key: 'tiger',
        title: 'Тигр',
        symbol: '🐅',
        element: 'wood',
        elementTitle: 'Дерево',
        color: '#e65100',
        bgGradient: 'linear-gradient(135deg, #ff9800 0%, #d84315 100%)',
        yearsDescription: '1962, 1974, 1986, 1998, 2010, 2022'
    },
    {
        key: 'rabbit',
        title: 'Кролик',
        symbol: '🐇',
        element: 'wood',
        elementTitle: 'Дерево',
        color: '#43a047',
        bgGradient: 'linear-gradient(135deg, #81c784 0%, #2e7d32 100%)',
        yearsDescription: '1963, 1975, 1987, 1999, 2011, 2023'
    },
    {
        key: 'dragon',
        title: 'Дракон',
        symbol: '🐉',
        element: 'earth',
        elementTitle: 'Земля',
        color: '#c2185b',
        bgGradient: 'linear-gradient(135deg, #ec407a 0%, #ad1457 100%)',
        yearsDescription: '1964, 1976, 1988, 2000, 2012, 2024'
    },
    {
        key: 'snake',
        title: 'Змея',
        symbol: '🐍',
        element: 'fire',
        elementTitle: 'Огонь',
        color: '#00897b',
        bgGradient: 'linear-gradient(135deg, #26a69a 0%, #00695c 100%)',
        yearsDescription: '1965, 1977, 1989, 2001, 2013, 2025'
    },
    {
        key: 'horse',
        title: 'Лошадь',
        symbol: '🐎',
        element: 'fire',
        elementTitle: 'Огонь',
        color: '#d32f2f',
        bgGradient: 'linear-gradient(135deg, #ef5350 0%, #b71c1c 100%)',
        yearsDescription: '1966, 1978, 1990, 2002, 2014, 2026'
    },
    {
        key: 'sheep',
        title: 'Коза',
        symbol: '🐐',
        element: 'earth',
        elementTitle: 'Земля',
        color: '#7cb342',
        bgGradient: 'linear-gradient(135deg, #aed581 0%, #558b2f 100%)',
        yearsDescription: '1967, 1979, 1991, 2003, 2015, 2027'
    },
    {
        key: 'monkey',
        title: 'Обезьяна',
        symbol: '🐒',
        element: 'metal',
        elementTitle: 'Металл',
        color: '#fbc02d',
        bgGradient: 'linear-gradient(135deg, #ffd54f 0%, #f57f17 100%)',
        yearsDescription: '1968, 1980, 1992, 2004, 2016, 2028'
    },
    {
        key: 'chicken',
        title: 'Петух',
        symbol: '🐓',
        element: 'metal',
        elementTitle: 'Металл',
        color: '#fb8c00',
        bgGradient: 'linear-gradient(135deg, #ffa726 0%, #ef6c00 100%)',
        yearsDescription: '1969, 1981, 1993, 2005, 2017, 2029'
    },
    {
        key: 'dog',
        title: 'Собака',
        symbol: '🐕',
        element: 'earth',
        elementTitle: 'Земля',
        color: '#6d4c41',
        bgGradient: 'linear-gradient(135deg, #8d6e63 0%, #4e342e 100%)',
        yearsDescription: '1970, 1982, 1994, 2006, 2018, 2030'
    },
    {
        key: 'pig',
        title: 'Свинья',
        symbol: '🐖',
        element: 'water',
        elementTitle: 'Вода',
        color: '#ab47bc',
        bgGradient: 'linear-gradient(135deg, #ba68c8 0%, #7b1fa2 100%)',
        yearsDescription: '1971, 1983, 1995, 2007, 2019, 2031'
    }
];

export function normalizeEasternKey(val: string | null | undefined): string {
    if (!val) return '';
    const clean = val.trim().toLowerCase();
    const byKey = EASTERN_SIGNS.find(z => z.key.toLowerCase() === clean);
    if (byKey) return byKey.key;
    const byTitle = EASTERN_SIGNS.find(z => z.title.toLowerCase() === clean);
    if (byTitle) return byTitle.key;

    if (clean.startsWith('крыс')) return 'rat';
    if (clean.startsWith('бык') || clean.startsWith('вол')) return 'ox';
    if (clean.startsWith('тигр')) return 'tiger';
    if (clean.startsWith('крол') || clean.startsWith('кот')) return 'rabbit';
    if (clean.startsWith('драк')) return 'dragon';
    if (clean.startsWith('зме')) return 'snake';
    if (clean.startsWith('лошад') || clean.startsWith('конь')) return 'horse';
    if (clean.startsWith('коз') || clean.startsWith('овц')) return 'sheep';
    if (clean.startsWith('обезь')) return 'monkey';
    if (clean.startsWith('петух') || clean.startsWith('кур')) return 'chicken';
    if (clean.startsWith('собак') || clean.startsWith('пес')) return 'dog';
    if (clean.startsWith('свин') || clean.startsWith('кабан') || clean.startsWith('хрю')) return 'pig';
    return '';
}

export function getEasternTitle(keyOrTitle: string | null | undefined): string {
    const key = normalizeEasternKey(keyOrTitle);
    const found = EASTERN_SIGNS.find(z => z.key === key);
    return found ? found.title : (keyOrTitle || '');
}

export function getEasternSign(keyOrTitle: string | null | undefined): EasternSign | undefined {
    const key = normalizeEasternKey(keyOrTitle);
    return EASTERN_SIGNS.find(z => z.key === key);
}

export function getEasternSymbol(keyOrTitle: string | null | undefined): string {
    const sign = getEasternSign(keyOrTitle);
    return sign ? sign.symbol : '🐾';
}

/**
 * Расчет животного по году рождения (базовый 12-летний цикл)
 */
export function getEasternSignByYear(year: number): EasternSign {
    // 1900 - Крыса (rat)
    const baseIndex = ((year - 1900) % 12 + 12) % 12;
    return EASTERN_SIGNS[baseIndex];
}
